import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:4000";

function DailyJournalCard({ token }) {
  const [journalStats, setJournalStats] = useState(null);

  useEffect(() => {
    let ignore = false;
    async function fetchJournalStats() {
      try {
        const res = await fetch(`${API_BASE_URL}/documents/journal_stats`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
          },
        });
        if (res.ok) {
          const data = await res.json();
          if (!ignore) setJournalStats(data);
        }
      } catch {
        // silent
      }
    }
    if (token) fetchJournalStats();
    return () => { ignore = true; };
  }, [token]);

  return (
    <div style={{ margin: "4px" }}>
      <Link
        to="/journal_editor"
        aria-label="Open Daily Journal"
        className="rounded-lg overflow-hidden border border-gray-300 hover:border-blue-500 transition flex flex-col w-full bg-white focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-1"
        style={{ height: "160px", textDecoration: "none" }}
      >
        <div className="px-4 py-2">
          <div className="text-gray-800 text-sm font-medium">Daily Journal&hellip;</div>
        </div>
        <div
          className="flex-1 bg-gray-50 border-t border-gray-200 flex flex-col items-center justify-center text-center text-gray-600 px-2"
          style={{ fontFamily: "'Courier Prime', 'Courier New', monospace", fontSize: "0.8rem" }}
        >
          {journalStats ? (
            <>
              <div>{journalStats.totalEntries} entries</div>
              <div>Streak {journalStats.currentStreak}</div>
              <div>Longest {journalStats.longestStreak}</div>
            </>
          ) : (
            <div>Loading...</div>
          )}
        </div>
      </Link>
    </div>
  );
}

export default DailyJournalCard;